<template>
  <div class="uk-margin">
    <div class="uk-grid uk-grid-small" data-uk-grid>
      <div class="uk-width-1-3@m">
        <div class="uk-margin">
          <label>
            <input
              class="uk-checkbox"
              type="checkbox"
              v-model="config.general.disableCart"
            />
            Warenkorb deaktivieren
          </label>
        </div>
      </div>
      <div class="uk-width-1-1">
        <div class="uk-align-left">
          <button type="submit" class="uk-button uk-button-primary" @click.prevent="store" :disabled="submitting">
            Speichern
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigService from '@/services/config.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  props: ['config'],
  data() {
    return {
      submitting: false
    }
  },
  methods: {
    async store() {
      this.submitting = true
      await ConfigService.store(this.config)
      this.submitting = false
      iziToast.success({
        title: 'OK',
        message: 'Einstellungen gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
      this.$emit('stored')
    }
  }
}
</script>
